import { render, staticRenderFns } from "./VDiscription.vue?vue&type=template&id=6c73a08e&"
import script from "./VDiscription.vue?vue&type=script&lang=js&"
export * from "./VDiscription.vue?vue&type=script&lang=js&"
import style0 from "./VDiscription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports